/* MCJ stateful add-to-cart.
   Always-visible elegant shopping-bag icon (bottom-right of each card). Hover shows
   a faint green-tick badge; adding flips it to a green circle with white bag + green
   tick badge (persists) and sends a sparkle to whichever cart icon is visible on screen.
   Clicking again removes it. Takes control of the card add button (no drawer popup,
   no double-add). Cart reads are no-store. After every add/remove the theme mini-cart
   drawer is refreshed via the Section Rendering API. It also watches ALL cart changes
   (incl. removing from the drawer/cart) and re-syncs the card icons so green clears. */
(function () {
  'use strict';
  var WRAP_SEL = 'quick-buy.bls__product-addtocart-js';
  var CART_FETCH = { headers: { 'Accept': 'application/json' }, credentials: 'same-origin', cache: 'no-store' };
  var CART_MUTATE_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var BAG_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5.8 9h12.4l-1 10.5H6.8L5.8 9z"/><path d="M8.5 9V7.5a3.5 3.5 0 0 1 7 0V9"/></svg>';
  var TICK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>';

  function setBadges(n) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      if (el.classList.contains('cart-count-drawer')) el.textContent = '(' + n + ')';
      else el.textContent = n;
    });
  }
  function getCart() { return fetch('/cart.js', CART_FETCH).then(function (r) { return r.json(); }); }
  function refreshCount() { return getCart().then(function (c) { setBadges(c.item_count); return c; }).catch(function () {}); }

  function drawerSectionId() {
    try { var cn = document.querySelector('cart-notification'); if (cn && cn.getSectionsToRender) { var s = cn.getSectionsToRender(); if (s && s[0] && s[0].id) return s[0].id; } } catch (e) {}
    return 'form-mini-cart';
  }
  function refreshDrawer() {
    var id = drawerSectionId();
    var cur = document.getElementById(id);
    if (!cur) return;
    fetch('/?sections=' + encodeURIComponent(id), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[id]; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(id);
        if (fresh) cur.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }
  function reconcile() { return refreshCount().then(function () { refreshDrawer(); }); }

  function ensureTick(btn) {
    if (btn.querySelector('.mc-tick')) return;
    var t = document.createElement('span');
    t.className = 'mc-tick'; t.setAttribute('aria-hidden', 'true');
    t.innerHTML = TICK_SVG;
    btn.appendChild(t);
  }
  function decorate(btn) {
    if (!btn) return;
    var icon = btn.querySelector('.bls__product-icon');
    if (icon && !icon.dataset.mcBag) { icon.innerHTML = BAG_SVG; icon.dataset.mcBag = '1'; }
    ensureTick(btn);
  }

  function hoist() {
    document.querySelectorAll('.bls__product-item:not([data-mc-hoisted])').forEach(function (item) {
      var img = item.querySelector('.bls__product-img');
      if (img) {
        var qb = img.querySelector(WRAP_SEL);
        if (qb) {
          if (qb.parentElement !== img) img.appendChild(qb);
          decorate(qb.querySelector('.bls__js-addtocart'));
        }
      }
      item.setAttribute('data-mc-hoisted', '1');
    });
  }

  function pop(btn) {
    btn.classList.remove('mc-pop'); void btn.offsetWidth; btn.classList.add('mc-pop');
    setTimeout(function () { btn.classList.remove('mc-pop'); }, 480);
  }
  function setAdded(wrap, btn, animate) {
    decorate(btn);
    wrap.classList.add('mc-added'); btn.classList.add('mc-added');
    btn.setAttribute('aria-label', 'In cart — tap to remove');
    var tip = btn.querySelector('.bls_tooltip-content'); if (tip) tip.textContent = 'Remove from cart';
    if (animate) pop(btn);
  }
  function setRemoved(wrap, btn, animate) {
    wrap.classList.remove('mc-added'); btn.classList.remove('mc-added');
    btn.setAttribute('aria-label', 'Add to cart');
    var tip = btn.querySelector('.bls_tooltip-content'); if (tip) tip.textContent = 'Add to cart';
    if (animate) pop(btn);
  }

  function cartTarget() {
    var list = [];
    ['#cart-icon-bubble', '.bls-minicart-action', '[data-bag-cart]', '.cart-count'].forEach(function (s) {
      document.querySelectorAll(s).forEach(function (e) { list.push(e); });
    });
    var vw = window.innerWidth, vh = window.innerHeight, best = null, bestTop = Infinity;
    list.forEach(function (e) {
      if (e.offsetParent === null) return;
      var r = e.getBoundingClientRect();
      if (r.width < 5 || r.height < 5 || r.height > 120) return;
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      if (cx < 2 || cx > vw - 2 || cy < 0 || cy > vh) return;
      if (r.top < bestTop) { bestTop = r.top; best = e; }
    });
    return best;
  }

  function flyToCart(btn) {
    if (!btn || typeof requestAnimationFrame === 'undefined') return;
    var b = btn.getBoundingClientRect();
    if (!b.width) return;
    var target = cartTarget(), ex, ey, bumpEl = null;
    if (target) { var t = target.getBoundingClientRect(); ex = t.left + t.width / 2; ey = t.top + t.height / 2; bumpEl = target.closest('a') || target; }
    else { ex = window.innerWidth - 30; ey = 28; }
    var sx = b.left + b.width / 2, sy = b.top + b.height / 2;
    var cx = (sx + ex) / 2, cy = Math.min(sy, ey) - 130;
    var s = document.createElement('div');
    s.className = 'mc-spark';
    s.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 1.6l2.6 6.9 7 .4-5.4 4.4 1.8 6.8L12 16.7 5.4 20.5l1.8-6.8L1.8 8.9l7-.4z"/></svg>';
    document.body.appendChild(s);
    var dur = 760, t0 = null;
    function ease(p) { return 1 - Math.pow(1 - p, 3); }
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1), e = ease(p);
      var x = (1 - e) * (1 - e) * sx + 2 * (1 - e) * e * cx + e * e * ex;
      var y = (1 - e) * (1 - e) * sy + 2 * (1 - e) * e * cy + e * e * ey;
      var sc = 1 - 0.55 * p, rot = p * 620;
      s.style.transform = 'translate(' + x + 'px,' + y + 'px) translate(-50%,-50%) scale(' + sc.toFixed(3) + ') rotate(' + rot.toFixed(1) + 'deg)';
      s.style.opacity = p < 0.8 ? '1' : ((1 - p) / 0.2).toFixed(2);
      if (p < 1) { requestAnimationFrame(frame); }
      else {
        s.remove();
        if (bumpEl) { bumpEl.classList.remove('mc-bump'); void bumpEl.offsetWidth; bumpEl.classList.add('mc-bump'); setTimeout(function () { bumpEl.classList.remove('mc-bump'); }, 460); }
      }
    }
    requestAnimationFrame(frame);
  }

  function addItem(wrap, btn) {
    if (wrap.dataset.mcBusy) return; wrap.dataset.mcBusy = '1';
    var vid = wrap.getAttribute('data-product-variant-id');
    setAdded(wrap, btn, true); flyToCart(btn);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: vid, quantity: 1 }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) { if (!res.ok) { setRemoved(wrap, btn, false); } return reconcile(); })
      .catch(function () { setRemoved(wrap, btn, false); })
      .finally(function () { delete wrap.dataset.mcBusy; });
  }
  function removeItem(wrap, btn) {
    if (wrap.dataset.mcBusy) return; wrap.dataset.mcBusy = '1';
    var vid = wrap.getAttribute('data-product-variant-id');
    setRemoved(wrap, btn, true);
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: vid, quantity: 0 }) })
      .then(function (r) { return r.json(); })
      .then(function () { return reconcile(); })
      .catch(function () {})
      .finally(function () { delete wrap.dataset.mcBusy; });
  }

  document.addEventListener('click', function (e) {
    var wrap = e.target && e.target.closest ? e.target.closest(WRAP_SEL) : null;
    if (!wrap) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = wrap.querySelector('.bls__js-addtocart') || wrap;
    if (wrap.classList.contains('mc-added')) removeItem(wrap, btn);
    else addItem(wrap, btn);
  }, true);

  function setRemovedQuiet(wrap, btn) {
    wrap.classList.remove('mc-added'); btn.classList.remove('mc-added');
    var tip = btn.querySelector('.bls_tooltip-content'); if (tip) tip.textContent = 'Add to cart';
  }
  function applyState(cart) {
    var ids = {}; (cart.items || []).forEach(function (i) { ids[String(i.variant_id)] = 1; });
    setBadges(cart.item_count);
    document.querySelectorAll(WRAP_SEL + '[data-product-variant-id]').forEach(function (wrap) {
      if (wrap.dataset.mcBusy) return;
      var btn = wrap.querySelector('.bls__js-addtocart') || wrap;
      decorate(btn);
      if (ids[wrap.getAttribute('data-product-variant-id')]) setAdded(wrap, btn, false);
      else setRemovedQuiet(wrap, btn);
    });
  }
  function sync() { return getCart().then(applyState).catch(function () {}); }

  function installCartWatch() {
    if (!window.fetch || window.__mcCartWatch) return; window.__mcCartWatch = 1;
    var orig = window.fetch, deb;
    window.fetch = function (input) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (CART_MUTATE_RE.test(url)) { p.then(function () { clearTimeout(deb); deb = setTimeout(sync, 350); }).catch(function () {}); }
      return p;
    };
  }

  function refresh() { hoist(); sync(); }

  function init() {
    refresh();
    installCartWatch();
    if (window.MutationObserver) {
      var deb, root = document.querySelector('.bls__grid') || document.querySelector('main, #MainContent') || document.body;
      var mo = new MutationObserver(function (muts) {
        var newCards = false;
        for (var i = 0; i < muts.length && !newCards; i++) {
          var nodes = muts[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType === 1 && ((n.matches && n.matches('.bls__product-item')) || (n.querySelector && n.querySelector('.bls__product-item')))) { newCards = true; break; }
          }
        }
        if (newCards) { clearTimeout(deb); deb = setTimeout(refresh, 500); }
      });
      mo.observe(root, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('pageshow', function () { refresh(); });
})();

/* ===== MCJ: remember a verified OTP and skip the custom checkout login/OTP step =====
   After a successful OTP verification on the custom checkout, remember it on this device
   for 30 days and auto-advance past the auth + OTP steps on later checkouts. Per-device
   only (not a real Shopify account session). No-op off the checkout page. Uses the
   checkout's own mcjState + mcjGoToStep so nothing in the existing flow is bypassed. */
(function () {
  'use strict';
  if (!document.getElementById('mcj-checkout')) return;
  var KEY = 'mcj_checkout_verified';
  var MAX_AGE = 30 * 24 * 60 * 60 * 1000;
  function getNote() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function valid(n) { return !!(n && n.phone && n.ts && (Date.now() - n.ts) < MAX_AGE); }
  function save(phone) { if (!phone) return; try { localStorage.setItem(KEY, JSON.stringify({ phone: phone, ts: Date.now() })); } catch (e) {} }
  /* Persist when the shopper moves past the OTP step (= a successful verification). */
  function watchVerify() {
    var obs = new MutationObserver(function () {
      var g = document.getElementById('step-gifting'), p = document.getElementById('step-payment');
      var movedOn = (g && g.classList.contains('active')) || (p && p.classList.contains('active'));
      if (movedOn) {
        var phone = (window.mcjState && window.mcjState.phone) || (document.getElementById('mcj-phone') || {}).value || '';
        if (phone) save(phone);
      }
    });
    ['step-otp', 'step-gifting', 'step-payment'].forEach(function (id) { var el = document.getElementById(id); if (el) obs.observe(el, { attributes: true, attributeFilter: ['class'] }); });
  }
  /* On load, if a recent verification exists, jump past auth + OTP. */
  function trySkip() {
    if (typeof window.mcjGoToStep !== 'function' || !window.mcjState) return false;
    if (window.mcjState.step && window.mcjState.step !== 'auth') return true;
    var n = getNote();
    if (!valid(n)) return false;
    if (!document.getElementById('step-gifting') && !document.getElementById('step-payment')) return false;
    window.mcjState.phone = n.phone;
    var pi = document.getElementById('mcj-phone'); if (pi) pi.value = n.phone;
    var cc = document.getElementById('mcj-consent-check'); if (cc) cc.checked = true;
    try { window.mcjGoToStep('step-gifting'); } catch (e) { return false; }
    return true;
  }
  function init() {
    if (location.pathname.indexOf('/account/logout') === 0) { try { localStorage.removeItem(KEY); } catch (e) {} return; }
    watchVerify();
    var tries = 0;
    var iv = setInterval(function () { tries++; if (trySkip() || tries > 25) clearInterval(iv); }, 150);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
